export default "__VITE_ASSET__eef95569__"